export default [
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Lead',
    },
    cell: {
      type: 'slot',
      name: 'lead',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Date created',
      sort: 'registeredAt',
    },
    cell: {
      type: 'slot',
      name: 'registeredAt',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Referrals amount',
    },
    cell: {
      type: 'slot',
      name: 'referralsAmount',
    },
  },
];
